"use client"

export default function ChairmanSection() {
    return (
        <section className="relative pt-0 pb-10 md:pb-16 xl:pb-20 2xl:pb-32 min-[1920px]:pb-40">
            <div className="w-full">
                <div className="relative grid grid-cols-1 xl:grid-cols-2 max-w-none mx-auto min-h-[250px] xl:min-h-[350px] 2xl:min-h-[450px] min-[1920px]:min-h-[600px]">

                    {/* Khu vực nội dung bên trái - GIỮ NGUYÊN */}
                    <div className="bg-[#EFEFEF] flex flex-col justify-center items-center text-center xl:items-start xl:text-left p-6 sm:p-8 md:p-12 md:pb-16 xl:p-16 xl:pl-28 xl:pb-24 2xl:p-24 2xl:pl-40 2xl:pb-32 min-[1920px]:p-32 min-[1920px]:pl-52 min-[1920px]:pb-44">
                        <p className="text-[#006633] text-[10px] xl:text-[10px] 2xl:text-[13px] min-[1920px]:text-[16px] font-[350] tracking-[0.25em] mb-2">
                            ROVI HOLDINGS
                        </p>

                        <h2
                            className="text-2xl md:text-3xl xl:text-4xl 2xl:text-5xl min-[1920px]:text-6xl font-[400] text-gray-800 mb-2 ml-0 xl:-ml-1"
                            style={{ fontFamily: '"Plus Jakarta Sans", sans-serif' }}
                        >
                            Ban lãnh đạo
                        </h2>

                        <p
                            className="text-gray-600 text-[12px] md:text-[13px] xl:text-[13px] 2xl:text-[16px] min-[1920px]:text-[20px] leading-relaxed max-w-full sm:max-w-[250px] 2xl:max-w-[350px] min-[1920px]:max-w-[450px]"
                            style={{ fontFamily: '"Helvetica Neue", Roboto, sans-serif' }}
                        >
                            Những doanh nhân dày dặn kinh nghiệm, tâm huyết, cùng chí hướng và khát vọng dấn thân.
                        </p>
                    </div>

                    {/* Khu vực nội dung bên phải */}
                    <div className="relative bg-emerald-600 pt-10 px-6 pb-0 sm:p-8 md:p-12 xl:p-16 2xl:p-24 min-[1920px]:p-32 flex flex-col justify-between items-center text-center xl:justify-center xl:items-start xl:text-left text-white overflow-hidden">
                        <video autoPlay loop muted playsInline className="absolute inset-0 w-full h-full object-cover">
                            <source src="/videos/bg-chutichtieng.mp4" type="video/mp4" />
                        </video>

                        <div className="relative z-10 w-full xl:w-auto xl:pl-20 2xl:pl-32 min-[1920px]:pl-44 flex flex-col items-center xl:items-start">
                            <h3
                                className="text-[14px] md:text-[15px] xl:text-[15px] 2xl:text-[20px] min-[1920px]:text-[26px] font-bold mb-2"
                                style={{ fontFamily: '"Plus Jakarta Sans", sans-serif' }}
                            >
                                Nguyễn Thị Kim Tiếng
                            </h3>

                            <p
                                className="text-[11px] md:text-[12px] xl:text-[12px] 2xl:text-[16px] min-[1920px]:text-[20px] mb-6 xl:mb-8 2xl:mb-10 min-[1920px]:mb-12 opacity-90 leading-normal"
                                style={{ fontFamily: '"Helvetica Neue", Roboto, sans-serif' }}
                            >
                                Founder – Chủ tịch HĐQT & TGĐ Rovi Holdings
                                <br />
                                Chủ nhiệm CLB Doanh Nhân 2030
                            </p>

                            <ul className="space-y-3 xl:space-y-4 2xl:space-y-5 min-[1920px]:space-y-7 text-[11px] xl:text-[12px] 2xl:text-[14px] min-[1920px]:text-[18px] flex flex-col items-center xl:items-start max-w-[280px] sm:max-w-[320px] xl:max-w-none mx-auto xl:mx-0">
                                <li className="text-center xl:text-left">
                                    <span style={{ fontFamily: '"Helvetica Neue", Roboto, sans-serif' }}>
                                        <span className="hidden xl:inline-block mr-3">•</span>
                                        Thạc Sĩ Quản Trị Kinh Doanh.
                                    </span>
                                </li>
                                <li className="text-center xl:text-left">
                                    <span style={{ fontFamily: '"Helvetica Neue", Roboto, sans-serif' }}>
                                        <span className="hidden xl:inline-block mr-3">•</span>
                                        Hơn 22 năm kinh nghiệm lĩnh vực du lịch.
                                    </span>
                                </li>
                                <li className="text-center xl:text-left">
                                    <span style={{ fontFamily: '"Helvetica Neue", Roboto, sans-serif' }}>
                                        <span className="hidden xl:inline-block mr-3">•</span>
                                        Người sáng lập và dẫn dắt Rovi Travel thành công từ năm 2004 đến nay.
                                    </span>
                                </li>
                            </ul>
                        </div>

                        {/* Ảnh minh họa Mobile - Sát đáy hoàn toàn */}
                        <div className="relative z-10 xl:hidden mt-10 w-full flex justify-center items-end">
                            <img
                                src="/images/About/chutich.png"
                                alt="Nguyễn Thị Kim Tiếng"
                                className="max-w-[220px] w-full h-auto object-contain object-bottom block"
                                style={{ marginBottom: '-1px' }} // Đảm bảo không có khoảng hở li ti ở đáy
                            />
                        </div>
                    </div>

                    {/* Ảnh minh họa Desktop - GIỮ NGUYÊN */}
                    <div className="absolute left-1/2 bottom-0 -translate-x-1/2 z-20 w-auto h-[130%] 2xl:h-[140%] min-[1920px]:h-[150%] pointer-events-none hidden xl:block">
                        <img
                            src="/images/About/chutich.png"
                            alt="Nguyễn Thị Kim Tiếng"
                            className="h-full w-auto object-contain object-bottom"
                        />
                    </div>
                </div>
            </div>
        </section>
    )
}